var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('guest',{attrs:{"pageType":2,"user_type":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }